export default __webpack_public_path__ + "static/media/welcome-back.4bac72f5.png";